import { Modal, Grid, DotLoading } from "antd-mobile";
import { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import styled from "styled-components";
import EqiupItem from '../../../../components/ECards/EqiupItem'
import useEquip from '../../../../hooks/useEquip'
export default function useEqiupsComposeModal() {
  const intl = useIntl()
  const show = ({ onConfrim = () => {}, onCancel=() => {},onSelect =() =>{},list = [],equips=[] }) => {
    return Modal.show({
      title: intl.formatMessage({id:'components.compose_modal.title',defaultMessage:"裝備合成"}),
      bodyClassName: "runbit_modal runbit_modal_25",
      showCloseButton: true,
      actions: [{
        key: "1",
        className: "border_btn",
        text: intl.formatMessage({id:'common.cancel',defaultMessage:"取消"}),
      },
      {
        key: "2",
        className: "primary_btn",
        text: intl.formatMessage({id:'components.compose',defaultMessage:"合成"}),
        primary: true,
        disabled: !list.length
      },],
      onAction: async (action, index) => {
        if(action.key === '1') {
          onCancel()
        } 
        if(action.key === '2') {
          await onConfrim()
        }
      },
      closeOnAction: false,
      content: <EqiupsComposeModal list={list} intl={intl}  equips={equips} onSelect={onSelect}/>,
    });
  };
  return {
    show,
  };
}

function EqiupsComposeModal({ list,onSelect,intl }) {
    const {composeFee} = useEquip({intl})
    const [fee,setFee] = useState()
    const [loading,setLoading] = useState()
    const getFee = async (equip) => {
      setLoading(true)
      try{
        const fee = await composeFee(equip.equipType,equip.ori_level)
        console.log('fee',fee)
        setFee(fee)
      }catch(e) {
        console.log(e)
        setLoading(false)
      }finally{

        setLoading(false)
      }
      
    }
    useEffect(() => {
      if(list && list.length) {
        getFee(list[list.length-1].equip)
      }
    },[])
  return (
    <div className="text-center">
      <Grid columns={2} gap={8}>
        <Grid.Item>
          {list[0]?<EqiupItem eqiup={list[0] } onClick={() => onSelect(0)}/> :<DefaultImage onClick={() => onSelect(0)}>
            <img src="/image/plus.png" alt="plus" />
          </DefaultImage>}
        </Grid.Item>
        <Grid.Item>
         {list[1]?<EqiupItem eqiup={list[1] } onClick={() => onSelect(1)}/> : <DefaultImage onClick={() => onSelect(1)}>
            <img src="/image/plus.png" alt="plus" />
          </DefaultImage>}
        </Grid.Item>
      </Grid>
      <Detail>
        <Grid columns={2} gap={8}>
          <Grid.Item>
            <div>{intl.formatMessage({id:'components.compose_modal.old_equip_level',defaultMessage:"舊裝備等級"})}</div>
            <div style={{ marginTop: ".8rem" }}>
              <strong>{(list && list.length === 2)? ('LV' + list[0].equip.level +' & LV' + list[1].equip.level):'-- & --'}</strong>
            </div>
          </Grid.Item>
          <Grid.Item>
            <div>{intl.formatMessage({id:'components.compose_modal.new_level',defaultMessage:"合成後等級"})}</div>
            <div style={{ marginTop: ".8rem" }}>
              <strong style={{ color: "#FF5C00" }}>{(list && list.length === 2)? ('LV' + (list[0].equip.level + 1)):'--'}</strong>
            </div>
          </Grid.Item>
        </Grid>
      </Detail>
      <Tip>
      {intl.formatMessage({id:'components.compose_modal.fee',defaultMessage:"合成费用共计"})} <strong> {loading ? <DotLoading /> :(fee !== undefined ? fee : '--') } RT</strong>
      </Tip>
    </div>
  );
}

const Image = styled.img`
  height: 11.0rem;

  width: auto;
  margin: auto;
`;

const DefaultImage = styled.div`
  width: 100%;
  height: 13.6rem;
  background: #f4f5f6;

  border: 1px solid #ffffff;
  border-radius: 1.2rem;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Detail = styled.div`
  background: #f4f5f6;
  box-shadow: .0rem .0rem 2px rgba(0, 0, 0, 0.08);
  border-radius: 1.6rem;
  padding: 1.6rem 0 1.6rem 4.0rem;
  margin-top: 2.0rem;
  text-align: left;
  font-style: normal;
  font-weight: 400;
  font-size: 1.3rem;
  line-height: 1.3rem;

  color: #969696;
  strong {
    font-size: 1.4rem;
    line-height: 1.4rem;

    color: #000000;
  }
`;

const Tip = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 1.4rem;
  line-height: 1.4rem;

  color: #969696;
  margin-top: 2.0rem;
  strong {
    color: #000;
  }
`;
